import React from "react";
import icon from "../../assets/community.png";

export default function CommunityIcon({ size }) {
  return <img src={icon} width={size} />;
}
